import { Component, OnInit, ViewChild, TemplateRef, EventEmitter, AfterViewInit } from '@angular/core';
import { BehaviorSubject, filter, map, pairwise, Subscription, throttleTime } from 'rxjs';
import { Task } from "../../models/task/task";
import { LookupValue } from '@affinite/common';
import { LookupService } from '../../services/lookup.service';
import { TaskService } from '../../services/task-service.service';
import { QueueService } from '../../services/queue.service';
import { FilterService } from '../../services/filter-service.service';
import { AutoUnsubscribe } from '../../shared/decorators/auto-unsubscribe.decorator';
import { MYQUEUETASKS, TASKSTATUS_SUCCESSFUL, TASKSTATUS_UNSUCCESSFUL } from 'projects/um/src/assets/constants';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { AppSettings } from '../../shared/appsettings';

@AutoUnsubscribe

@Component({
    selector: 'app-my-queue-tasks',
    templateUrl: './my-queue-tasks.component.html',
    styleUrls: ['./my-queue-tasks.component.scss'],
    standalone: false
})
export class MyQueueTasksComponent implements OnInit, AfterViewInit {
  @ViewChild('filterTaskDialogTemplate') filterTaskTemplate: TemplateRef<any> | undefined;
  @ViewChild(CdkVirtualScrollViewport) virtualScroll!: CdkVirtualScrollViewport;

  filterBadgeData = { text: '', count: 0 }
  openDialogEvent = new EventEmitter<boolean>();
  tasks!: Task[];
  allTasks: Task[]=[];
  totalTasks = 0;
  lookupValues!: LookupValue[];
  successId!: number[];
  unsuccessfulId!: number[];
  filterType = MYQUEUETASKS;
  searchPageNumber = 0;
  maxQueueCount = 0;
  countMessage = '';

  constructor(private queueService: QueueService,
    private taskService: TaskService,
    private lookupService: LookupService,
    private filterService: FilterService,
    private appSettings: AppSettings) {
    this.maxQueueCount = this.appSettings.maxQueueCount;
  }

  //Refresh task queue icon 
  refreshTitleText = 'Refresh task queue';
  refreshQueue() {
    this.taskService.getTaskListByOwner();
  }

  sub!: Subscription;
  allTasksList = new BehaviorSubject<Task[]>([]);

  ngOnInit(): void {
    this.taskService.getTaskListByOwner();
    this.sub = this.lookupService.LookupData.subscribe(l => {
      if (l && l.length > 0) {
        this.lookupValues = l;
        this.successId = l.filter(t => t.lookupStandardValue.toLowerCase() === TASKSTATUS_SUCCESSFUL.toLowerCase()).map(o => o.lookupValueID);
        this.unsuccessfulId = l.filter(t => t.lookupStandardValue.toLowerCase() === TASKSTATUS_UNSUCCESSFUL.toLowerCase()).map(o => o.lookupValueID);
        if (this.tasks) {
          this.statusFilter();
          this.allTasksList.next(this.tasks);
          //this.totalTasks = this.tasks.filter(t => t.hidden == false).length;
        }
      }
    })

    this.sub.add(this.taskService.userTaskList.subscribe(data => {
      if (data.length > 0) {
        this.allTasks = [...data];
        //this.statusFilter();
        var pagedData = this.getPagedTaskQueueByOwner(0, this.maxQueueCount);
        if (pagedData) {
          this.tasks = pagedData;
          this.tasks.sort((a, b) => this.queueService.sortTasks(a, b));
          //this.tasks = [...this.filterService.applySessionFilter(this.tasks, MYQUEUETASKS)];
          
          this.allTasksList.next(this.tasks);
          this.countMessage = `${this.tasks.length.toLocaleString()} of ${this.allTasks.length.toLocaleString()}`;
        }
      }
    }));
    
    this.sub.add((this.taskService.taskUpdated.subscribe(data => {
      if (data) {
        this.taskService.getTaskListByOwner();
      }
    })));

    this.sub.add(this.filterService.badgeDataBs.subscribe(bd => {
      if (bd.filter_type == MYQUEUETASKS) {
        this.filterBadgeData = bd;
      }
    }));
  }

  getPagedTaskQueueByOwner(skipRows: number, takeRows: number) {
    if (this.allTasks) {
      let queueList = [...this.allTasks];
      queueList = this.filterService.applySessionFilter(queueList, MYQUEUETASKS);
      queueList = queueList.filter(t => t.hidden == false);
      this.totalTasks = queueList.length;
      let totalRows = skipRows + takeRows;
      if (skipRows > queueList.length) {
        return null;
      }
      if (totalRows > queueList.length) {
        takeRows = queueList.length - skipRows;
      }
      return queueList.slice(skipRows, takeRows + skipRows);
    } else {
      return null;
    }
  }

  ngAfterViewInit() {
    this.virtualScroll.elementScrolled().pipe(
      map(() => this.virtualScroll.measureScrollOffset('bottom')),
      pairwise(),
      filter(([y1, y2]) => (y2 < y1 && y2 < 140)),
      throttleTime(200)
    ).subscribe(() => {
      this.searchPageNumber++;
      let pagedData = this.getPagedTaskQueueByOwner(this.searchPageNumber * this.maxQueueCount, this.maxQueueCount);
      if (pagedData) {
        let tasks = this.tasks.concat(pagedData);
        this.tasks = [...tasks];
        this.tasks.sort((a, b) => this.queueService.sortTasks(a, b));
        //this.tasks = [...this.filterService.applySessionFilter(this.tasks, MYQUEUETASKS)];
        //this.statusFilter();
        this.allTasksList.next(this.tasks);
        //this.totalTasks = this.tasks.filter(t => t.hidden == false).length;
        this.countMessage = `${this.tasks.length.toLocaleString()} of ${this.totalTasks.toLocaleString()}`;
      }
    })
  }

  statusFilter() {
    this.tasks = this.tasks.filter(t => (!this.successId.includes(t.statusId) && !this.unsuccessfulId.includes(t.statusId)));
  }

  openFilterDialog() {
    this.searchPageNumber = 0;
    this.openDialogEvent.emit(true);
  }

  dialogEvent(tasks: Task[]) {
    let takeRows = 0;
    this.tasks = tasks.filter(a => a.hidden == false);
    let totalCount = this.tasks.length.toLocaleString();
    let totalRows = this.maxQueueCount;
      if (this.maxQueueCount > tasks.length) {
        //do nothing
      }
      if (totalRows > this.tasks.length) {
        takeRows = this.tasks.length - this.maxQueueCount;
      }
      this.tasks = [...this.tasks.slice(0, (takeRows + this.maxQueueCount))];

    //this.statusFilter();
    //this.totalTasks = this.tasks.filter(a => a.hidden == false).length
    this.countMessage = `${this.tasks.length.toLocaleString()} of ${totalCount}`;
    this.allTasksList.next(this.tasks);
  }

  displayCountEvent(count: number) {
    //this.totalTasks = count;
  }
}
